<template>
  <div>
    <div class="bj-section">
      <div class=" title">{{ welcome }}{{ info.nickname || user.id }} <img class="member-icon" src="@/assets/image/member-icon.png" /></div>
      <div class="lg-record">
        <span>上次登录：{{ info.lastLoginAt }}</span>
        <span style="margin-left: 10px">{{ info.lastLoginIp }} {{ info.lastAddr }}</span>
      </div>
    </div>
    <div class=" bj-container">
      <div class=" title-section">
        <div class="us-title">我的钱包</div>
        <div class="">
          <Button class="color-F85A36 wd-100 hg-40 radius-40" to="/my/finance/account/recharge">充值</Button>
          <Button class="border-F85A36 wd-100 hg-40 radius-40 ml-20" to="/my/finance/account/cashout">提现</Button>
        </div>
      </div>
      <div class="bj-rows">
        <div class="u-panl">
          <div class="f-price">{{ fbalance }}</div>
          <div class="label">可用余额</div>
        </div>
        <div class="u-panl">
          <div class="ff-price">{{ ffreezeAmount }}</div>
          <div class="label">冻结余额</div>
        </div>
      </div>
    </div>
    <div class="bj-container">
      <div class="title-section">
        <div class="us-title">我的域名</div>
        <router-link class="t-more" to="/my/domain">查看全部 ></router-link>
      </div>
      <div class="bj-rows nk-box">
        <router-link class="ur-link" to="/my/domain">
          <img class="icon" src="@/assets/image/user-n1-icon.png" alt="" srcset="" />
          <img class="icon h" src="@/assets/image/user-n1a-icon.png" alt="" srcset="" />
          <div class="text">我的域名</div>
        </router-link>
        <router-link class="ur-link" to="/my/template">
          <img class="icon" src="@/assets/image/user-n2-icon.png" alt="" srcset="" />
          <img class="icon h" src="@/assets/image/user-n2a-icon.png" alt="" srcset="" />
          <div class="text">我的模板</div>
        </router-link>
        <router-link class="ur-link" to="/my/transferout">
          <img class="icon" src="@/assets/image/user-n3-icon.png" alt="" srcset="" />
          <img class="icon h" src="@/assets/image/user-n3a-icon.png" alt="" srcset="" />
          <div class="text">我的转出</div>
        </router-link>
        <router-link class="ur-link" to="/my/transferin">
          <img class="icon" src="@/assets/image/user-n4-icon.png" alt="" srcset="" />
          <img class="icon h" src="@/assets/image/user-n4a-icon.png" alt="" srcset="" />
          <div class="text">我的转入</div>
        </router-link>
        <router-link class="ur-link" to="/my/push">
          <img class="icon" src="@/assets/image/user-n5-icon.png" alt="" srcset="" />
          <img class="icon h" src="@/assets/image/user-n5a-icon.png" alt="" srcset="" />
          <div class="text">域名Push</div>
        </router-link>
        <router-link class="ur-link" to="/my/order">
          <img class="icon" src="@/assets/image/user-n6-icon.png" alt="" srcset="" />
          <img class="icon h" src="@/assets/image/user-n6a-icon.png" alt="" srcset="" />
          <div class="text">域名订单</div>
        </router-link>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { userInfo } from "api/user.js";
export default {
  name: "user",
  data() {
    return {
      info: {},
    };
  },
  computed: {
    ...mapState(["user", "freezeAmount", "balance"]),
    welcome() {
      let title = "";
      let hours = new Date().getHours();
      if (hours < 12) {
        title = "上午好！";
      } else if (hours >= 12 && hours < 14) {
        title = "中午好！";
      } else if (hours >= 14 && hours < 19) {
        title = "下午好！";
      } else if (hours >= 19 && hours <= 24) {
        title = "晚上好！";
      }
      return title;
    },
    fbalance(){
      return this.balance.toFixed(2) 
    },
    ffreezeAmount(){
      return this.freezeAmount.toFixed(2)
    },
  },
  created() {
    this.req_userInfo();
  },
  methods: {
    async req_userInfo() {
      try {
        const { code, data } = await userInfo();
        if (code === 200) {
          this.info = data;
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>
<style lang="less" scoped>
  .member-icon{
    width: 24px;
    height: 19px;
  }
  .bj-section{
    border-radius: 6px;
    background-color: #202224;
    padding: 40px 46px 35px;
    .title{
      font-size: 20px;
      font-weight: bold;
      color: #FFFFFF;
      line-height: 35px;
    }
  }
  .lg-record{
      font-size: 14px;
      font-weight: 400;
      color: #626164;
      line-height: 25px;
    }
  .bj-container{
    margin-top: 20px;
    padding: 25px 30px 50px;
    border-radius: 6px;
    background-color: #f85a36;
    background-image: linear-gradient(155deg, #bb3623 0%, #462620 17%, #352322 20%, #202224 25%);
    min-height: 230px;
  }
  .title-section{
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 40px;
    .us-title{
      font-size: 18px;
      color: #fff;
      font-weight: bold;
    }
  }
  .u-panl{
    flex: 1;
    text-align: center;
    .f-price{
      color: #F85A36;
      font-size: 36px;
      line-height: 45px;
    }
    .ff-price{
      color: #fff;
      font-size: 36px;
      line-height: 45px;
    }
    .label{
      font-size: 14px;
      line-height: 28px;
      color: #626164;
    }
  }
  .t-more{
    cursor: pointer;
    color: #515a6e;
  }
  .ur-box{
    flex: 1;
    text-align: center;
    .ur-box-r{
      border-right: 1px solid #FAEBE6;
    }
    .u-itemd-icon{
      width: 50px;
      height: 50px;
      margin-top: 24px;
    }
    .b-count{
      color: #fff;
      font-size: 36px;
      font-weight: bold;
      margin-bottom: 20px;
    }
    .b-title{
      color: #737577;
    }
  }
  .nk-box{
    flex-wrap: wrap;
    justify-content: flex-start;
    .ur-link{
      flex: 0 0 30%;
      padding: 0 15px;
      margin-left: 20px;
      margin-bottom: 20px;
      height: 90px;
      line-height: 90px;
      border-radius: 90px;
      background-color: #37393B;
      display: flex;
      align-items: center;
      .icon{
        width: 61px;
        height: 61px;
        background-color: #4E4E50;
        border-radius: 50%;
      }
      .icon.h{
          display: none;
      }
      .text{
        color: #737577;
        margin-left: 20px;
        font-size: 16px;
      }
      &:hover{
        color: #fff;
        background-color: #F85936;
        .icon{
          display: none;
        }
        .icon.h{
          display: block;
          background-color: #fff;
        }
        .text{
          color: #fff;
        }
      }
    }
  }
</style>
